import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../theme";

interface LHCheckboxProps {
  value: boolean;
  onValueChange: () => void;
}

const LHCheckbox: React.FC<LHCheckboxProps> = ({ value, onValueChange }) => {
  const { colors } = useTheme();
  return (
    <TouchableOpacity
      style={styles.checkbox}
      onPress={onValueChange}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: value }}
    >
      <MaterialIcons
        name={value ? "check-box" : "check-box-outline-blank"}
        size={24}
        color={value ? colors.brand.primary : colors.text.secondary}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  checkbox: {
    padding: 8,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default LHCheckbox;
